const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';

const areas = [
  'Silivri',
  'Selimpaşa',
  'Gümüşyaka',
  'Çanta',
  'Değirmenköy',
  'Marmaraereğlisi',
  'Yeniçiftlik',
  'Tekirdağ Yolu',
];

export default function ServiceAreas() {
  return (
    <section id="bolgeler" className="relative bg-brand-dark py-20 md:py-28">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            Hizmet Verilen Bölgeler
          </h2>
          <p className="text-brand-muted text-base md:text-lg max-w-2xl mx-auto">
            Bölgenizi WhatsApp’tan iletin, destek ve uygunluk bilgisi alın.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto">
          {areas.map((area) => (
            <a
              key={area}
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center justify-center gap-2 bg-brand-surface hover:bg-brand-surfaceLight border border-white/10 hover:border-brand-accent/50 rounded-xl p-4 md:p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-brand-accent/10"
            >
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-brand-accent/10 group-hover:bg-brand-accent/20 transition-colors">
                <i className="fas fa-location-dot text-brand-accent text-sm md:text-base"></i>
              </div>
              <span className="text-white font-semibold text-sm md:text-base text-center">
                {area}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}